import {
  Button,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography
} from '@material-ui/core';
import {AddCircle, Edit, Delete, VisibilityOff, Visibility, Settings} from '@material-ui/icons';
import React, {useEffect, useRef, useState} from 'react';
import { useHistory } from 'react-router-dom';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import Loading from "../../UiComponents/Loading";
import {gameRepository} from "../../../Domain/Repositories/GameRepository";
import GamePointsSettings, {PointsPerLife} from "../../../Domain/Models/GamePointsSettings";
import {TrafficShapingService} from "../../../Domain/Services/TrafficShapingService";
import {TrafficShapingSettings} from "../../../Domain/Models/TrafficShapingSettings";
import GamePointsModal from "./GamePointsModal";
import {cubeRepository} from "../../../Domain/Repositories/CubeRepository";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
  maintenanceModeCube: {
    backgroundColor: '#ff2929'
  }
}));

export default function GamePointsContent()
{
  const classes = useStyles();
  const history = useHistory();

  const errorCardControllerRef = useRef<ErrorCardController>(null);

  const [loading, setLoading] = useState(false);
  const [trafficShapingSettings, setTrafficShapingSettings] = useState<TrafficShapingSettings>();
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [gameIndexToEdit, setGameIndexToEdit] = useState(0);
  
  const handleEditClicked = (index: number) =>
  {
    setEditDialogOpen(true);
    setGameIndexToEdit(index);
  }

  const handleDialogClose = () =>
  {
    setEditDialogOpen(false);
    forceReload();
  }

  const handleAddEntry = () =>
  {
    setLoading(true);

    const gamePointsSettings: GamePointsSettings = JSON.parse(JSON.stringify(gameRepository.gamePointsSettings));
    gamePointsSettings.gameScores.push({
      oneLife: 0,
      twoLives: 0,
      threeLives: 0,
    });

    gameRepository.updateGamePoints(gamePointsSettings)
      .then(() =>
      {
        forceReload();
      })
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardControllerRef.current?.addErrorMessage(e.message)
      });
  }
  
  const handleRemoveLastEntry = () =>
  {
    setLoading(true);

    const gamePointsSettings: GamePointsSettings = JSON.parse(JSON.stringify(gameRepository.gamePointsSettings));
    gamePointsSettings.gameScores.pop();

    gameRepository.updateGamePoints(gamePointsSettings)
      .then(() =>
      {
        forceReload();
      })
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardControllerRef.current?.addErrorMessage(e.message)
      });
  }

  const forceReload = () =>
  {
    setLoading(true);
    
    gameRepository.getGamePoints()
      .then(() =>  TrafficShapingService.getSettings())
      .then((trafficSettings: TrafficShapingSettings) =>
      {
        setTrafficShapingSettings(trafficSettings);
        setLoading(false);
      })
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardControllerRef.current?.addErrorMessage(e.message)
      });
  }

  useEffect(() =>
  {
    forceReload();
  }, [])

  return (
    <>
      <Loading isLoading={loading}>
        <ErrorCardController ref={errorCardControllerRef}/>
        
        <GamePointsModal
          open={editDialogOpen}
          onClose={handleDialogClose}
          gamePointsSettings={gameRepository.gamePointsSettings}
          gameIndex={gameIndexToEdit}
          pointsPerLife={gameRepository.gamePointsSettings.gameScores[gameIndexToEdit]}
          />

        <Paper className={classes.paper}>
          <Toolbar>
            <Typography className={classes.title} component="h2" variant="h6" color="primary" gutterBottom>
              Game Points
            </Typography>
          </Toolbar>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Game Number</TableCell>
                  <TableCell>3 Lives</TableCell>
                  <TableCell>2 Lives</TableCell>
                  <TableCell>1 Life</TableCell>
                  <TableCell/>
                </TableRow>
              </TableHead>
              <TableBody>
                {gameRepository.gamePointsSettings.gameScores.map((x: PointsPerLife, index) => (
                  <TableRow key={`PointsPerLife_${index}`} hover>
                    <TableCell>
                      {index + 1}
                    </TableCell>
                    <TableCell>
                      {x.threeLives}
                    </TableCell>
                    <TableCell>
                      {x.twoLives}
                    </TableCell>
                    <TableCell>
                      {x.oneLife}
                    </TableCell>
                    <TableCell>
                      <IconButton size="small" color="default" onClick={() => handleEditClicked(index)}>
                        <Edit/>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>


          <Button onClick={handleAddEntry} color="primary">
            Add Cube
          </Button>
          <Button
            onClick={handleRemoveLastEntry}
            color="secondary"
            disabled={gameRepository.gamePointsSettings.gameScores.length == 0}
          >
            Remove Last
          </Button>

        </Paper>
      </Loading>
    </>
  );
}